import { connect } from 'react-redux';
import { FlatInfo } from '../components/flat_info';
import { getColoredPolygons } from '../components/polygons_drawer/helpers';
import { createStaticMapImageUrlOfferPhase } from '../utils/map/polygon';
import { getMVKHouseById } from '../utils/mvk_data';
import { getFlatsInSectionFloor } from '../utils/parsers/flats';
var STATIC_MAP_IMAGE_SIZE = [160, 120];
function mapStateToProps(state) {
  var MVKData = state.MVKData,
    _state$MVKState = state.MVKState,
    flat = _state$MVKState.flat,
    isOfferCard = _state$MVKState.isOfferCard;
  var currentFlat = MVKData.offers.find(function (offer) {
    return offer.id === flat.id;
  });
  var floor = currentFlat && currentFlat.floor;
  var selectedHouse = currentFlat && getMVKHouseById(MVKData, currentFlat.houseId);
  var selectedSection = currentFlat && selectedHouse && selectedHouse.sections.find(function (section) {
    return section.number === currentFlat.sectionNumber;
  });
  var floorScheme = selectedSection && floor && selectedSection.floorPlans.find(function (floorPlan) {
    return floorPlan.floors.includes(floor);
  });
  var flatPolygons = currentFlat && floorScheme && selectedSection && getColoredPolygons(floorScheme.floorPlanFlats, getFlatsInSectionFloor(MVKData, currentFlat.houseId, selectedSection.id, floor), undefined, currentFlat.flatNumber);
  return {
    builder: MVKData.builder,
    flat: currentFlat,
    floorFlatPolygons: flatPolygons || undefined,
    mapImageUrl: createStaticMapImageUrlOfferPhase(STATIC_MAP_IMAGE_SIZE, selectedHouse, selectedSection),
    isOfferCard: isOfferCard
  };
}
export var FlatInfoContainer = connect(mapStateToProps)(FlatInfo);